<template>
  <span class="context-container">
    <slot name="anchor" />
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="displayed" class="pop-up" :class="position">
        <span class="context-bg" @click="close" />
        <div class="context-menu">
          <span class="title"><slot name="title" /></span>
          <slot class="context-menu" name="content" />
        </div>
      </div>
    </transition>
  </span>
</template>
<script>
export default {
  props: {
    displayed: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'bottom-right',
      validator: value => (['top-left', 'top-right', 'right', 'bottom-left', 'bottom-right', 'left'].indexOf(value) > -1),
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .context-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba($primary-300, 0.8);
    @media #{$screen-width-medium} { background: transparent; }
  }

  .context-container {
    position: relative;

    @media #{$screen-width-medium} {
      position: relative;
    }
  }

  .pop-up {
    position: fixed;
    z-index: 9999999999; // go above intercom
    animation-duration: 0.3s;

    @media #{$screen-width-medium} {
      position: absolute;

      &.top-left {
        right: 0;
        bottom: 100%;
        margin-bottom: 1rem;
      }

      &.top-right {
        left: 0;
        bottom: 100%;
        margin-bottom: 1rem;
      }

      &.bottom-left {
        right: 0;
        top: 100%;
        margin-top: 0.75rem;
      }

      &.bottom-right {
        left: 0;
        top: 100%;
        margin-top: 0.75rem;
      }

      &.right {
        left: 100%;
        top: 0;
        margin-left: 0.75rem;
      }

      &.left {
        right: 100%;
        top: 0;
        margin-right: 0.75rem;
      }
    }
  }

  .context-menu {
    background-color: $white;
    border-radius: 0.25rem;
    margin: 0.5rem;
    border: 1px solid $pearl-300;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding: 0 0.5rem;
    @media #{$screen-width-medium} {
      position: relative;
      bottom: none;
      left: none;
      margin: 0;
      text-align: left;
      padding: 0.5rem;
    }
  }

</style>
